import { Helmet } from "react-helmet-async";
import { Outlet } from "react-router";
import ChatwootWidget from "~/components/ChatwootWidget";
import Header from "~/components/Header";
import MetaTags from "~/components/MetaTags";
import MissingInformationModal from "~/components/MissingInformationModal";
import OgImage from "~/components/OgImage";

export default function RootLayout() {
  return (
    <>
      <Helmet>
        <link href="/apple-touch-icon.png" rel="apple-touch-icon" sizes="180x180" />
        <link href="/site.webmanifest" rel="manifest" />
        <link color="#3182CE" href="/maskable.png" rel="mask-icon" />
        <link href="/blog/feed.xml" rel="alternate" title="WebGazer Blog feed" type="application/atom+xml" />
        <meta content="#117BBF" name="theme-color" />
      </Helmet>

      <ChatwootWidget />

      <MissingInformationModal />

      <MetaTags />

      <OgImage image={{ height: 1260, url: "/og-image.png", width: 2400 }} />

      <div className="d-flex flex-column flex-grow-1">
        <Header />

        <Outlet />
      </div>
    </>
  );
}
